/**
 * venuePricingSlice — single source of truth for the Service Charge & Tax card.
 *
 * Hydrated from the SSR fetch via VenuePricingInitializer; the card seeds its
 * editable fields from here and dispatches `setVenuePricing` after a successful
 * save so the store stays in sync (mirrors `companySettingsSlice`).
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PricingSettings } from "@/components/settings/venues/pricing/types";

export interface VenuePricingState {
  pricing: PricingSettings | null;
  loading: boolean;
}

const initialState: VenuePricingState = {
  pricing: null,
  loading: true,
};

const venuePricingSlice = createSlice({
  name: "venuePricing",
  initialState,
  reducers: {
    /** Replace the pricing settings — used to hydrate from the API on mount. */
    setVenuePricing(state, action: PayloadAction<PricingSettings | null>) {
      state.pricing = action.payload;
    },
    setVenuePricingLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setVenuePricing, setVenuePricingLoading } =
  venuePricingSlice.actions;

export default venuePricingSlice.reducer;
